import { HTTP_TOKEN } from "./http";

export const getConversionWhats = (params) => {
  return HTTP_TOKEN.get("conversion-whatsapp", { params }).then((result) => {
    return result.data;
  });
};

export const getConversionWhat = (whatsId) => {
  return HTTP_TOKEN.get(`conversion-whatsapp/${whatsId}`).then((result) => {
    return result.data;
  });
};

export const createConversionWhats = (data) => {
  return HTTP_TOKEN.post("conversion-whatsapp", data).then((result) => {
    return result.data;
  });
};

export const updateConversionWhats = (whatsId, params) => {
  return HTTP_TOKEN.put(`conversion-whatsapp/${whatsId}`, params).then((result) => {
    return result.data;
  });
};

export const deleteConversionWhats = (whatsId) => {
  return HTTP_TOKEN.delete(`conversion-whatsapp/${whatsId}`, {}).then((result) => {
    return result.data;
  });
};

